<template>
  <!-- Dynamic XY coords: +50px on 'X' because of lateral left strip of map's container  -->
  <div
    class="contextMenu"
    :class="{ enabled: clickToContextMenu }"
    :style="{ top: position.y + 'px', left: position.x  + 50 + 'px' }"
  >
    <div v-if="canEdit" class="contextMenu-item" @click="clickEdit">
      <span class="contextMenu-icon glyphicons glyphicons-pencil"></span>
      {{ $t('map.DrawContour.ContourActions.edit', {0: selectedDrawFeature.values_.name }) }}
    </div>
    <div class="contextMenu-item" @click="clickDelete">
      <span class="contextMenu-icon glyphicons glyphicons-bin"></span>
      {{ $t('map.DrawContour.ContourActions.delete', {0: selectedDrawFeature.values_.name }) }}
    </div>
  </div>
</template>

<script>

export default {
  name: 'context-menu',

  props: {
    clickToContextMenu: {
      type: Boolean,
      required: true
    },
    position: {
      type: Object,
      required: true
    },
    selectedDrawFeature: {
      type: Object,
      required: true
    }
  },

  computed: {
    canEdit () {
      return !this.selectedDrawFeature.get('isMultiPolygonPart')
    }
  },

  created () {
    window.addEventListener('click', this.handleWindowClick)
  },

  beforeDestroy () {
    window.removeEventListener('click', this.handleWindowClick)
  },

  methods: {
    handleWindowClick (e) {
      if (!this.$el.contains(e.target)) {
        this.$emit('clickOutside')
      }
    },

    clickEdit () {
      this.$emit('clickEdit')
      this.$emit('clickOutside')
    },

    clickDelete () {
      this.$emit('clickDelete')
      this.$emit('clickOutside')
    }
  }
}
</script>

<style lang="less">
.contextMenu {
  position: absolute;
  display: none;
  top: 0;
  left: 0;

  z-index: 3;
  min-width: 200px;
  padding: 4px 0;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
  color: @gray800;
  background-color: @white;
  cursor: pointer;

  &.enabled {
    display: block;
  }
}

.contextMenu-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px;
  white-space: nowrap;

  .contextMenu-icon {
    flex: 0 0 16px;
    color: @primaryGreen;
    text-align: center;
  }

  &:hover {
    color: @white;
    background-color: @primaryGreen;

    .contextMenu-icon {
      color: @white;
    }
  }
}
</style>
